const autoNgTemplateLoaderTemplate1 = require('./logs.html');

import controller from './logsController';

export const logsView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
